import "./index.scss";

const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="18"
      viewBox="0 0 25 18"
      fill="none"
    >
      <path
        d="M9.26074 12.582L2.66895 5.99121L0 8.65918L9.33984 17.999L12.0088 15.3311L11.9297 15.251L24.5117 2.66895L21.8428 0L9.26074 12.582Z"
        fill="currentColor"
      />
    </svg>
  );
};

type Props = {
  journey1: {
    title: string;
    items: string[];
  };
  journey2: {
    title: string;
    items: string[];
  };
  journey3: {
    title: string;
    items: string[];
  };
};

export const SolutionJourney = ({ journey1, journey2, journey3 }: Props) => {
  return (
    <div className="solution-journey">
      <div className="journey-items">
        <div className="journey-item" key={journey1.title}>
          <div className="text">
            {journey1.items.map((item, index) => (
              <div key={`${item}-index`} className="text-row">
                {item}
              </div>
            ))}
          </div>
          <div className="title">{journey1.title}</div>
          <div className="circle">
            <CheckIcon />
          </div>
        </div>
        <div className="journey-item" key={journey2.title}>
          <div className="circle">
            <CheckIcon />
          </div>
          <div className="title">{journey2.title}</div>
          <div className="text">
            {journey2.items.map(item => (
              <div key={`${item}-index`} className="text-row">
                {item}
              </div>
            ))}
          </div>
        </div>
        <div className="journey-item" key={journey3.title}>
          <div className="text">
            {journey3.items.map(item => (
              <div key={`${item}-index`} className="text-row">
                {item}
              </div>
            ))}
          </div>
          <div className="title">{journey3.title}</div>
          <div className="circle">
            <CheckIcon />
          </div>
        </div>
      </div>
      <svg
        className="timeline"
        xmlns="http://www.w3.org/2000/svg"
        width="542"
        height="55"
        viewBox="0 0 542 55"
        fill="none"
      >
        <path
          d="M3.00001 2.99993C31.2061 2.99993 64.7104 2.99994 149.295 2.99995L174.292 52C214.05 52 306.878 52 347.038 52L381.285 2.99998L518.07 3L539 3"
          stroke="white"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M3.00001 2.99993C31.2061 2.99993 64.7104 2.99994 149.295 2.99995L174.292 52C214.05 52 306.878 52 347.038 52L381.285 2.99998L518.07 3L539 3"
          stroke="url(#paint0_linear_6510_7921)"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_6510_7921"
            x1="3"
            y1="54.0688"
            x2="572.668"
            y2="54.0688"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00EBC8" />
            <stop offset="0.177877" stopColor="#00EBC8" />
            <stop offset="0.903857" stopColor="#DD00FF" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
